import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.643789, 166.93621, 9.4],
  [-11.643761, 166.936285, 9.4],
  [-11.643717, 166.936355, 9.4],
  [-11.643658, 166.936415, 9.6],
  [-11.643585, 166.936459, 9.6],
  [-11.643499, 166.936473, 9.6],
  [-11.64341, 166.93646, 9.6],
  [-11.643324, 166.936431, 9.6],
  [-11.643239, 166.936395, 9.6],
  [-11.643154, 166.936354, 9.6],
  [-11.643069, 166.936311, 9.6],
  [-11.642985, 166.936266, 9.6],
  [-11.642898, 166.93622, 9.6],
  [-11.64281, 166.936173, 9.6],
  [-11.642721, 166.936127, 9.6],
  [-11.64263, 166.936084, 9.6],
  [-11.642538, 166.936039, 9.6],
  [-11.642447, 166.935989, 9.6],
  [-11.642355, 166.935942, 9.6],
  [-11.642254, 166.935918, 9.6],
  [-11.64215, 166.93593, 9.6],
  [-11.642052, 166.935969, 9.4],
  [-11.641958, 166.936021, 9.4],
  [-11.641869, 166.936082, 9.4],
  [-11.641792, 166.936159, 9.6],
  [-11.641714, 166.936232, 10],
  [-11.641634, 166.936298, 10.6],
  [-11.641555, 166.936361, 11],
  [-11.64148, 166.936423, 11.6],
  [-11.641408, 166.936485, 12],
  [-11.64134, 166.936549, 12.4],
  [-11.641273, 166.936612, 12.4],
  [-11.641202, 166.936671, 12.4],
  [-11.641139, 166.936742, 12.4],
  [-11.641109, 166.936835, 12.4],
  [-11.641101, 166.936935, 12.4],
  [-11.641101, 166.937034, 12.4],
  [-11.641107, 166.937133, 12.4],
  [-11.641118, 166.937236, 12.4],
  [-11.641135, 166.937335, 12.6],
  [-11.641163, 166.937434, 12.4],
  [-11.641217, 166.937523, 12.2],
  [-11.641314, 166.937565, 11.6],
  [-11.641424, 166.937572, 11],
  [-11.641539, 166.937571, 10.4],
  [-11.641652, 166.937611, 9.8],
  [-11.641711, 166.937716, 9.4],
  [-11.641721, 166.937837, 9.4],
  [-11.641711, 166.937964, 9.4],
  [-11.641697, 166.938086, 9.6],
  [-11.641697, 166.938207, 9.6],
  [-11.64172, 166.938323, 9.6],
  [-11.641752, 166.938438, 9.6],
  [-11.64177, 166.938555, 9.6],
  [-11.641765, 166.938672, 9.6],
  [-11.641748, 166.938791, 9.6],
  [-11.641726, 166.938907, 9.6],
  [-11.641701, 166.939022, 9.6],
  [-11.641675, 166.939139, 9.6],
  [-11.641651, 166.939253, 9.6],
  [-11.64163, 166.939368, 9.6],
  [-11.641604, 166.939481, 9.6],
  [-11.641557, 166.939585, 9.6],
  [-11.641485, 166.939679, 9.4],
  [-11.641402, 166.939756, 9.4],
  [-11.641304, 166.939821, 9.4],
  [-11.641195, 166.939861, 9.4],
  [-11.641085, 166.939853, 9.4],
  [-11.640982, 166.939801, 9.4],
  [-11.64089, 166.939732, 9.4],
  [-11.640797, 166.939664, 9.6],
  [-11.640689, 166.939631, 9.6],
  [-11.640576, 166.939635, 9.6],
  [-11.640464, 166.939634, 9.6],
  [-11.640366, 166.939579, 9.6],
  [-11.640302, 166.939486, 9.6],
  [-11.640259, 166.939381, 9.6],
  [-11.640222, 166.939273, 9.6],
  [-11.640179, 166.939168, 9.6],
  [-11.640111, 166.939077, 9.6],
  [-11.640015, 166.939019, 9.6],
  [-11.639908, 166.938983, 9.6],
  [-11.639797, 166.938967, 9.6],
  [-11.639685, 166.938978, 9.6],
  [-11.639584, 166.939025, 9.6],
  [-11.639507, 166.93911, 9.6],
  [-11.639452, 166.939209, 9.6],
  [-11.639409, 166.939311, 9.6],
  [-11.639369, 166.939418, 9.6],
  [-11.639332, 166.939527, 9.6],
  [-11.639295, 166.939635, 9.6],
  [-11.639259, 166.939741, 9.6],
  [-11.639217, 166.939848, 9.6],
  [-11.639166, 166.939947, 9.6],
  [-11.639104, 166.940044, 9.6],
  [-11.63904, 166.940136, 9.6],
  [-11.638978, 166.940233, 9.6],
  [-11.638941, 166.94034, 9.6],
  [-11.638939, 166.940451, 9.6],
  [-11.638963, 166.940562, 9.8],
  [-11.639002, 166.940668, 9.8],
  [-11.639049, 166.940769, 10],
  [-11.639101, 166.940867, 10],
  [-11.639157, 166.940964, 10.2],
  [-11.639215, 166.941056, 10.2],
  [-11.639275, 166.941147, 10.4],
  [-11.639345, 166.941231, 10.4],
  [-11.639424, 166.941305, 10.4],
  [-11.639508, 166.941374, 10.4],
  [-11.639592, 166.941442, 10.4],
  [-11.639673, 166.941522, 10.4],
  [-11.639727, 166.941608, 10.4],
  [-11.639761, 166.941711, 10.4],
  [-11.639777, 166.941819, 10.4],
  [-11.639792, 166.941926, 10.4],
  [-11.639832, 166.942026, 10.4],
  [-11.639898, 166.942114, 10.4],
  [-11.639974, 166.942191, 10.4],
  [-11.640055, 166.942262, 10.4],
  [-11.640137, 166.942328, 10.4],
  [-11.640224, 166.942393, 10.4],
];

export default stream;
